module.exports = __webpack_public_path__ + "img/pastorImage.2414b203.png";